import React from 'react'

const Mention = () => {
  return (
    <>
    <h1 className='text-black text-lg mt-5 font-bold font-crimson-text smd:mt-20 slg:text-3xl smd:text-2xl xl:text-4xl text-center'>MENTIONS LÉGALES</h1>

    <p className='font-biryani text-black text-xs text-left mt-3 xl:text-base xl:mt-10 ml-10 mr-10'>
        Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il est précisé aux utilisateurs du site Instant bien être l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
    </p>

    <h2 className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-left xl:mt-28 ml-5'>Edition du site</h2>

    <p className='font-biryani text-black text-xs text-left mt-3 xl:text-base xl:mt-10 ml-10 mr-10'>
        Le présent site, accessible à l’URL https://instantbienetre-coralie.com/ (le « Site »), est édité par :

        Instant bien être, société au capital de 4000 euros, inscrite au R.C.S. de CHARTRES sous le numéro RCS Chartres 824 881 536 ainsi qu'au R.M. sous le numéro 824 881 536 000 26,, dont le siège social est situé au 8 rue du docteur taugourdeau, représenté(e) par Coralie Casanova dûment habilité(e)

        Le numéro individuel TVA de l’éditeur est : FR 000.
    </p>

    <h2 className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-left xl:mt-28 ml-5'>Hébergement</h2>

    <p className='font-biryani text-black text-xs text-left mt-3 xl:text-base xl:mt-10 ml-10 mr-10'>
        Le Site est hébergé par la société OVH SAS, situé 2 rue Kellermann - BP 80157 - 59053 Roubaix Cedex 1, (contact téléphonique ou email : 1007).
    </p>

    <h2 className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-left xl:mt-28 ml-5'>Directeur de publication</h2>

    <p className='font-biryani text-black text-xs text-left mt-3 xl:text-base xl:mt-10 ml-10 mr-10'>
        Le Directeur de la publication du Site est Coralie Casanova .
    </p>

    <h2 className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-left xl:mt-28 ml-5'>Nous contacter</h2>

    <p className='font-biryani text-black text-xs text-left mt-3 xl:text-base xl:mt-10 ml-10 mr-10'>
        Par téléphone : +33635168696
        Par email : instantbienetretremblay@gmail.com
        Par courrier : 28170

    </p>
    </>
  )
}

export default Mention